import { type GetWorkerRequirementsResponse } from "@clipboard-health/contract-worker-app-bff";
import { type UseInfiniteGetQueryOptions } from "@src/appV2/api/useInfiniteGetQuery";
import { type AxiosError } from "axios";

import { type WorkerRequirement } from "../types";
import { useGetPaginatedWorkerRequirements } from "../useGetPaginatedWorkerRequirements";
import { requirementRelationship } from "../useGetWorkerRequirements";

interface UseGetOptionalWorkplaceLevelRequirementsProps {
  qualifications: string[];
}

export function useGetOptionalRequirements(
  props: UseGetOptionalWorkplaceLevelRequirementsProps,
  options: UseInfiniteGetQueryOptions<
    GetWorkerRequirementsResponse,
    AxiosError,
    WorkerRequirement[]
  > = {}
) {
  const { qualifications } = props;

  return useGetPaginatedWorkerRequirements(
    {
      filter: {
        qualifications,
        requiredForBooking: false,
        visibleToWorker: true,
      },
      include: [...requirementRelationship],
      page: { size: 10 },
    },
    options
  );
}
